import { Section } from '@web_opxp/components';
import * as React from 'react';
import BlogPreviewWrapper from '../components/BlogPreview/BlogPreviewWrapper';
import SideStory from '../components/SideStory/SideStory';
import NewsletterReminder from './NewsletterReminder';
import SessionOverview from './SessionOverview';

export interface ISessionOverviewSideStorySectionProps {
  domain: number;
  visible: boolean;
  subscribedToNewsletter: boolean;
  onNewletterSubscribe: () => void;
}

export const SessionOverviewSideStorySection: React.FC<ISessionOverviewSideStorySectionProps> = ({
  domain,
  visible,
  subscribedToNewsletter,
  onNewletterSubscribe,
}) => {
  if (!visible) return null;
  return (
    <Section>
      <div data-testid="session-overview-side-story-section" className="row">
        <div className="col-6">
          <SessionOverview />
        </div>
        <div className="col-2" />
        <div className="col-4">
          <SideStory domain={domain} />
          <BlogPreviewWrapper />
          <NewsletterReminder visible={!subscribedToNewsletter} onClick={onNewletterSubscribe} />
        </div>
      </div>
    </Section>
  );
};

export default SessionOverviewSideStorySection;
